export enum AddButtonTypeEnum {
  DEFAULT = 'DEFAULT',
  FEEDBACK = 'FEEDBACK',
}
